import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import styles from './Progress.module.scss';
import clsx from 'clsx';

export const Progress = props => {
 const {
   className,
   percentage = 50,
   strokeWidth = 18,
   showPercentage = true,
   strokeColor = 'var(--primary)',
   color = '#fff',
   ...other
 } = props;

  const barStyle = useMemo(() => ({
      width: percentage + '%',
      backgroundColor: strokeColor,
    }), [percentage, strokeColor]);

  return (
    <div className={clsx(styles.progress, className)} {...other}
       role="progressbar"
       aria-valuenow={percentage}
       aria-valuemin="0"
       aria-valuemax="100"
    >
      <div className={styles.progressBar}>
        <div className={styles.progressBarOuter} style={{height: strokeWidth + 'px', color}}>
          <div className={styles.progressBarInner} style={barStyle}>
            {showPercentage && (<div className={styles.progressBarInnerText}>{percentage}%</div>)}
          </div>
        </div>
      </div>
    </div>
  );
};

Progress.propTypes = {
  percentage: PropTypes.number,
  strokeWidth: PropTypes.number,
  strokeLinecap: PropTypes.oneOf(['round', 'square']),
  color: PropTypes.string,
  width: PropTypes.number,
  showPercentage: PropTypes.bool
};

export default Progress;
